export enum FeedbackForFeature {
  /** used for prompting users early feature request access */
  FeatureRequest = `feature_request`,

  AdvancedDeletion = `Advanced Deletion`,
  BehaviorMetrics = `Behavior Metrics`,
  Boards = `Boards`,
  Browse = `Search & Discover`,
  Experiments = `Experiments`,
  FeatureFlags = `Feature Flags`,
  FirstClassMetrics = `First Class Metrics`,
  FoundationalTemplates = `Foundational Templates`,
  General = `General`,
  HeatMaps = `Heatmaps`,
  Home = `Home`,
  Lexicon = `Lexicon`,
  LexiconUpdates = `Lexicon Updates`,
  LiveviewEventInspector = `Liveview Event Inspector`,
  Localization = `Localization`,
  NewDropdowns2021 = `New Dropdowns 2021`,
  OnboardingChecklist = `Onboarding Checklist`,
  SidebarQB = `Query Panel`,
  SessionReplay = `Session Replay`,
  Spark = `Spark`,
  SparkCopilot = `Spark Copilot`,
  StarterBoard = `Starter Board`,
  TextAnalysis = `Text Analysis`,
  WarehouseImports = `Warehouse Imports`,
  MetricTrees = `Metric Trees`,
}

export enum FeedbackType {
  Dealbreaker = `dealbreaker`,
  PainPoint = `pain_point`,
  Beta = `beta`,
  NotWorking = `not_working`,
}

export enum Sentiment {
  Positive = `positive`,
  Negative = `negative`,
}
